(ns journal-app-client.modals.feedback
  (:require [journal-app-client.utils.react :as react]
            [re-frame.core :as rf]))

(defn background []
  [:<>
   [:div
    {:style {:position "absolute"
             :width    "100%"
             :height   "100%"
             :z-index  0
             :background-image "radial-gradient(var(--border) 0.5px, transparent 0.5px), radial-gradient(var(--border) 0.5px, transparent 0.5px)"
             :background-size "20px 20px"
             :background-position "0 0, 10px 10px"}}]
   [:div
    {:style {:position "absolute"
             :width    "42.5vmax"
             :height   "42.5vmax"
             :z-index  0
             :opacity "0.8"
             :border "0.25rem dotted var(--border)"
             :border-radius "100vmax"
             :animation "spin-initial-loader 180s linear reverse"}}]
   [:div
    {:style {:position "absolute"
             :width    "65vmax"
             :height   "65vmax"
             :z-index  0
             :opacity "0.6"
             :border "0.125rem solid var(--border)"
             :border-radius "100vmax"}}]
   [:div
    {:style {:position "absolute"
             :width    "75vmax"
             :height   "75vmax"
             :z-index  0
             :opacity "0.45"
             :border "0.5rem dotted var(--border)"
             :border-radius "100vmax"
             :animation "spin-initial-loader 180s linear infinite"}}]
   [:div
    {:style {:position "absolute"
             :width    "80vmax"
             :height   "80vmax"
             :z-index  0
             :opacity "0.3"
             :border "0.125rem solid var(--border)"
             :border-radius "100vmax"}}]
   [:div
    {:style {:position "absolute"
             :width    "85vmax"
             :height   "85vmax"
             :z-index  0
             :opacity "0.1"
             :border "0.125rem solid var(--border)"
             :border-radius "100vmax"}}]])

(defn main-fn [id props]
  (let [failure? (:failure? props)
        db-updates (:db-updates props)
        shared-state-path (or (:shared-state-path props) [])
        changes-synced? (when-not failure? @(rf/subscribe [:state-change-synced? props]))]
    [:<>
     [:div
      {:style {:position "relative"
               :width "100%"
               :height "100%"
               :display "flex"
               :flex-direction "column"
               :justify-content "space-evenly"
               :align-items "center"
               :padding "1rem"
               :text-align "center"}
       :on-click #(rf/dispatch [:close-modal id])}
      [background]
      [:h1.title {:style {:z-index "1"
                          :color (when failure? "var(--yellow)")}}
       (if failure?
         "Server sync failed..."
         (if changes-synced?
           "Saved!"
           "Syncing changes with server..."))]
      (if failure?
        [:span.icon
         {:style {:font-size "40vmin"
                  :z-index   "1"
                  :color     "var(--yellow)"
                  :filter    "drop-shadow(0 0 3vmin black)"}}
         [:i.fas.fa-exclamation]]
        [:span.icon
         {:style {:font-size "40vmin"
                  :z-index   "1"
                  :color     "white"
                  :filter    "drop-shadow(0 0 3vmin black)"
                  :animation (when-not changes-synced? "spin-initial-loader 10s linear infinite")}}
         (if changes-synced?
           [:i.fas.fa-check]
           [:i.fas.fa-cog])])
      [:p.subtitle {:style {:z-index "1"}} "Click anywhere in the blank area to close"]]]))